var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnviarUnPitazo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_37_2",
    "data-name": "Componente 37 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_316",
    "data-name": "Trazado 316",
    d: "M108.76,264.971a2.124,2.124,0,0,0-2.917-.861,2.227,2.227,0,0,0-.963,2.957,2.124,2.124,0,0,0,2.917.861A2.227,2.227,0,0,0,108.76,264.971Z",
    transform: "translate(-99.806 -253.161)",
    fill: "#47476b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    d: "M17.939,5.608,15.754,1.467a.527.527,0,0,0-.712-.22L9,4.431a.527.527,0,0,0-.221.712L9.336,6.2l-1.868.982L6.912,6.127A.527.527,0,0,0,6.2,5.906L3.285,7.443A6.145,6.145,0,0,0,.862,16.019l-.4.4a1.575,1.575,0,0,0,2.227,2.227l.41-.41a6.159,6.159,0,0,0,8.952-7.088,2.063,2.063,0,0,1,1.051-2.411l4.61-2.412a.527.527,0,0,0,.222-.713ZM1.948,17.9a.52.52,0,0,1-.736-.735l.271-.271a6.11,6.11,0,0,0,.74.731ZM7.743,15.97a3.457,3.457,0,0,1-4.735-1.42A3.578,3.578,0,0,1,4.536,9.792a3.457,3.457,0,0,1,4.735,1.42h0A3.578,3.578,0,0,1,7.743,15.97Z",
    transform: "translate(1 -0.143)",
    fill: "#47476b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_318",
    "data-name": "Trazado 318",
    d: "M153.649,9.729a.466.466,0,1,0,.825-.434l-.689-1.31a.466.466,0,0,0-.825.434Z",
    transform: "translate(-146.459 -6.49)",
    fill: "#47476b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    "data-name": "Trazado 319",
    d: "M99.449,81.33a14.642,14.642,0,0,0,1.507.316.466.466,0,0,0,.1-.922l-1.407-.306a.466.466,0,0,0-.2.911Z",
    transform: "translate(-94.528 -76.554)",
    fill: "#47476b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    "data-name": "Trazado 320",
    d: "M226.048,6.177a.466.466,0,0,0,.608-.255l.554-1.353a.466.466,0,0,0-.863-.353l-.554,1.353A.466.466,0,0,0,226.048,6.177Z",
    transform: "translate(-216.727 -2.8)",
    fill: "#47476b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_148138",
    "data-name": "Rect\\xE1ngulo 148138",
    width: 20,
    height: 20,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviarUnPitazo);
export default __webpack_public_path__ + "static/media/enviar-un-pitazo.fe50d08135f03a79181582eaf69b3f67.svg";
export { ForwardRef as ReactComponent };